import { SSelect } from '@avalara/skylab-sdk/react';
import { useDispatch, useSelector } from 'react-redux';

import { selectState } from '../../../selectors';
import { setMarketingDataField } from '../../../store/data';

const ConnectorSelect = () => {
  const dispatch = useDispatch();
  const {
    data: { marketingData, connectors },
  } = useSelector(selectState);

  const defaultOption = {
    label: 'Select which integration you use',
    value: '',
  };
  const formattedConnectors = [defaultOption].concat(
    connectors.data.map(({ name, id }) => ({ label: name, value: id, selected: marketingData.connector === id })),
  );

  return (
    <fieldset>
      <SSelect
        data-ref='risk-assessment.connector-select'
        id='connector-select'
        inputId='connector-select'
        optionsList={formattedConnectors}
        onS-select={(e) => dispatch(setMarketingDataField({ field: 'connector', data: e.detail.item.value }))}
      />
    </fieldset>
  );
};

export default ConnectorSelect;
